var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.297,
    height: 29.297,
    viewBox: "0 0 29.297 29.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "smile-2",
    d: "M18.649,4A14.649,14.649,0,1,0,33.3,18.649,14.649,14.649,0,0,0,18.649,4Zm4.578,8.789a1.465,1.465,0,1,1-1.465,1.465A1.465,1.465,0,0,1,23.226,12.789Zm-9.155,0a1.465,1.465,0,1,1-1.465,1.465A1.465,1.465,0,0,1,14.071,12.789Zm11.9,9.024a7.691,7.691,0,0,1-7.324,4.893,7.691,7.691,0,0,1-7.324-4.893.734.734,0,1,1,1.392-.469,6.109,6.109,0,0,0,5.933,3.9,6.109,6.109,0,0,0,5.859-3.9.734.734,0,0,1,1.392.469Z",
    transform: "translate(-4 -4)",
    fill: "#ebebeb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.61c0561fdb2bd79d2361c2ca2cd3dcce.svg";
export { ForwardRef as ReactComponent };